export enum InwardStatus {
    Inward = "inward",
    Survey = "survey",
    Workout = "workout",
    DocumentPending = "documentPending",
    Checking = "checking",
    Typing = "typing",
    Outward = "outward",
    Cancel = "cancel",
    Delivered = "delivered",
}

export const InwardStatusData = {
    [InwardStatus.Inward]: "Inward",
    [InwardStatus.Survey]: "Survey",
    [InwardStatus.Workout]: "Workout",
    [InwardStatus.DocumentPending]: "Document Pending",
    [InwardStatus.Checking]: "Checking",
    [InwardStatus.Typing]: "Typing",
    [InwardStatus.Outward]: "Outward",
    [InwardStatus.Cancel]: "Cancel",
    [InwardStatus.Delivered]: "Delivered",
}
